module.exports = __webpack_public_path__ + "static/media/carp_mobile_booking_account.12f09735.gif";